import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveSmallLeaderboardTopThreeDrop } from "./WaveSmallLeaderboardTopThreeDrop";
import { WaveSmallLeaderboardDefaultDrop } from "./WaveSmallLeaderboardDefaultDrop";
interface MemesWaveSmallLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly isApproveWave?: boolean | undefined;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
  readonly onDropClick: () => void;
}
export const MemesWaveSmallLeaderboardDrop: React.FC<MemesWaveSmallLeaderboardDropProps> = t0 => {
  const $ = _c(9);
  const {
    drop,
    isApproveWave: t1,
    isVotingClosed: t2,
    isVotingControlsLocked: t3,
    onDropClick
  } = t0;
  const isApproveWave = t1 === undefined ? false : t1;
  const isVotingClosed = t2 === undefined ? false : t2;
  const isVotingControlsLocked = t3 === undefined ? false : t3;
  let t4;
  if ($[0] !== drop || $[1] !== isApproveWave || $[2] !== isVotingClosed || $[3] !== isVotingControlsLocked || $[4] !== onDropClick) {
    t4 = !isApproveWave && typeof drop.rank === "number" && drop.rank <= 3 ? <WaveSmallLeaderboardTopThreeDrop drop={drop} onDropClick={onDropClick} /> : <WaveSmallLeaderboardDefaultDrop drop={drop} isVotingClosed={isVotingClosed} isVotingControlsLocked={isVotingControlsLocked} isApproveWave={isApproveWave} onDropClick={onDropClick} />;
    $[0] = drop;
    $[1] = isApproveWave;
    $[2] = isVotingClosed;
    $[3] = isVotingControlsLocked;
    $[4] = onDropClick;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onDropClick || $[7] !== t4) {
    t5 = <div className="tw-cursor-pointer" onClick={onDropClick}>{t4}</div>;
    $[6] = onDropClick;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};